module.exports = "/assets/data/38b38bd4abe257060655346cb581eb3a-DE13.data.json";